import { z } from 'zod';
var FeatureFlags = z.record(z.string(), z["boolean"]().optional());
export var FeatureFlagsResponse = z.object({
  type: z.literal('feature_flags'),
  attributes: FeatureFlags
});